// Module
var code = "<div class=\"instruction-field-wrapper instruction-field-wrapper--history\"> <div class=\"instruction-field instruction-field--history\"> <div class=\"p-0 of-h\" data-ng-bind-html=\"$ctrl.instructionText\" ng-class=\"{'isMobile': $ctrl.isMobile}\"></div> </div> </div> ";
// Exports
export default code;